<template>
  <div class="vd-gl-content">
    <a-form-model
      ref="ruleForm"
      style="margin-top: 40px"
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="归属人工号" prop="codeType">
        <a-input class="vd-input-xs" v-model="form.code" />
        <span class="check-icon">
          <a-tag v-if="checkStatus === undefined" @click="checkCode">
            <a-icon v-if="checkLoading" type="loading"></a-icon> 检测
          </a-tag>
          <a-tag
            v-else-if="checkStatus === true"
            color="#87d068"
            @click="checkCode"
          >
            <a-icon type="check"></a-icon> 用户存在
          </a-tag>
          <a-tag v-else color="#f50" @click="checkCode">
            <a-icon type="close"></a-icon> 未检测到
          </a-tag>
        </span>
      </a-form-model-item>

      <a-form-model-item label="群清单" prop="codeType">
        <a-textarea
          class="vd-input-l"
          v-model="form.group"
          placeholder="群号用 ',' (英文逗号)隔开。如:8400001444,959874214,22357422"
        ></a-textarea>
        <span class="check-icon">
          <a-tag v-if="checkStatusG === undefined" @click="checkGroup">
            <a-icon v-if="checkLoadingG" type="loading"></a-icon> 检测
          </a-tag>
          <a-tag
            v-else-if="checkStatusG === true"
            color="#87d068"
            @click="checkGroup"
          >
            <a-icon type="check"></a-icon> 通过
          </a-tag>
          <a-tag v-else color="#f50" @click="checkGroup">
            <a-icon type="close"></a-icon> 未通过
          </a-tag>
        </span>
      </a-form-model-item>

      <a-form-model-item label="群机器人所属地区">
        <a-tooltip title="选择群所属地区，此项设置错误，可能导致群信息识别失败">
          <a-select
            style="width: 108px"
            v-model="form.area"
            placeholder="请选择"
          >
            <template v-for="(item, index) in areaList">
              <a-select-option :value="item.login_qq" :key="index">
                {{ item.zh }}
              </a-select-option>
            </template>
          </a-select>
        </a-tooltip>
      </a-form-model-item>

      <template v-if="diffList.length > 0">
        <a-form-model-item label="未匹配到的群">
          <a-table
            :data-source="diffList"
            :pagination="false"
            rowKey="id"
            size="small"
          >
            <a-table-column title="群号" align="center" data-index="group_qq" />
            <a-table-column title="操作" align="center">
              <span slot-scope="record">
                <a-tag
                  v-if="record.status === 0"
                  @click="pullInfo(record)"
                  color="red"
                >
                  拉取群信息
                </a-tag>
              </span>
            </a-table-column>
            <a-table-column title="结果" align="center">
              <span slot-scope="record">
                {{ record.result }}
              </span>
            </a-table-column>
          </a-table>
        </a-form-model-item>
      </template>

      <template v-if="normalList.length > 0">
        <a-form-model-item label="配置群基础数据">
          <a-table
            :data-source="normalList"
            :pagination="false"
            rowKey="id"
            size="small"
          >
            <a-table-column title="群号" align="center" data-index="group_qq" />
            <a-table-column
              title="地区"
              align="center"
              data-index="area_name"
            />
            <a-table-column
              title="项目"
              align="center"
              data-index="category_name"
            />
            <a-table-column title="操作" align="center">
              <span slot-scope="record">
                <a-tag @click="setInfo(record)" color="blue">
                  设置归属信息
                </a-tag>
              </span>
            </a-table-column>
            <a-table-column title="结果" align="center">
              <span slot-scope="record">
                {{ record.result }}
              </span>
            </a-table-column>
          </a-table>
        </a-form-model-item>
      </template>

      <a-form-model-item :wrapper-col="{ span: 24 }" align="center">
        <a-button type="primary" @click="band">绑定</a-button>
      </a-form-model-item>
    </a-form-model>
    <!-- 社群信息 -->
    <a-modal
      :visible="visible"
      title="修改社群信息"
      ok-text="确认"
      cancel-text="取消"
      @ok="qqConfirm"
      @cancel="qqCancel"
    >
      <a-form-model
        ref="qqForm"
        :model="qqForm"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="归属地市" prop="name">
          <a-cascader
            style="width: 216px"
            :options="areaTree"
            v-model="qqForm.areaPath"
            :field-names="{
              label: 'name',
              value: 'id',
              children: 'children',
            }"
            placeholder="请选择用户所属地区"
            :change-on-select="true"
          />
        </a-form-model-item>

        <a-form-model-item label="归属考试" prop="name">
          <a-select
            style="width: 216px"
            v-model="qqForm.category"
            placeholder="归属考试类型"
          >
            <template v-for="item in subList">
              <a-select-option :key="item.id">
                {{ item.nickname }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  user_verify,
  group_verify,
  pull_group,
  band_group,
  qq_modify,
} from '@/api/qq'
//1111111
import { get_sub } from '@/api/category'
import { get_area_tree } from '@/api/auth'
import store from '@/store'

export default {
  name: 'Manager',
  data() {
    return {
      visible: false,
      checkStatus: undefined,
      checkLoading: false,
      checkStatusG: undefined,
      checkLoadingG: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      diffList: [],
      normalList: [],
      areaList: [],
      areaTree: [],
      subList: [],
      form: {
        code: undefined,
        group: '',
        area: undefined,
      },
      qqForm: {
        id: undefined,
        areaPath: [],
        category: undefined,
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: 9,
        hideOnSinglePage: true,
        onChange: (page) => {
          this.pagination.current = page
        },
      },
    }
  },
  created() {
    this.areaList = store.getters.qqRoot
    // 获取下拉中的数据
    get_area_tree().then((res) => {
      if (res.code === 1) {
        this.areaTree = res.areaTree
      }
    })
    get_sub('item_type').then((res) => {
      if (res.code === 1) {
        this.subList = res.list
      }
    })
  },
  methods: {
    checkCode() {
      if (this.checkStatus === undefined) {
        // 输入检测
        if (!this.$HelperUtil.isEmpty(this.form.code)) {
          this.checkLoading = true
          user_verify({ code: this.form.code }).then((res) => {
            this.checkLoading = false
            this.checkStatus = res.code === 1
            console.log(res)
          })
        } else {
          this.$message.info({ content: '请输入维护者工号', key: 'code' })
        }
      }
    },
    checkGroup() {
      if (this.checkStatusG === undefined) {
        // 输入检测
        if (!this.$HelperUtil.isEmpty(this.form.group)) {
          // 检测合法
          let rep = new RegExp('[\u4e00-\u9fa5 a-zA-Z]')
          let result = rep.test(this.form.group)
          if (result) {
            this.$message.info({
              content: '请检查群清单输入是否正确',
              key: 'group',
            })
            return false
          }
          this.checkLoadingG = true
          group_verify({
            group: this.form.group,
          }).then((res) => {
            this.checkLoadingG = false
            if (res.code === 1) {
              this.checkStatusG = res.diff.length === 0
              this.diffList = res.diff
              this.normalList = res.normalList
            } else {
              this.checkStatusG = undefined
              this.$message.warning(res.msg)
            }
          })
        } else {
          this.$message.info({ content: '请输入要绑定的群列表', key: 'group' })
        }
      }
    },
    // 拉取信息
    pullInfo(record) {
      if (this.form.area === undefined) {
        this.$message.info('请设置群所属地区!')
      } else {
        pull_group({
          group_qq: record.group_qq,
          login_qq: this.form.area,
        }).then((res) => {
          record.result = res.msg
          if (res.code === 1) {
            record.status = 1
            this.checkStatusG = undefined
            this.checkGroup()
          }
        })
      }
    },
    // 设置所属信息
    setInfo(record) {
      this.visible = !this.visible
      this.qqForm.id = record.id
    },
    band() {
      // 检测 输入信息 是否都通过
      if (!this.checkStatus || !this.checkStatusG) {
        this.$message.error({ content: '请对输入数据进行检查。', key: 'band' })
        return false
      }
      if (!this.form.area) {
        this.$message.error({ content: '请选择群所属地区', key: 'band' })
        return false
      }
      // 绑定接口对接
      band_group({
        code: this.form.code,
        group_list: this.form.group,
        login_qq: this.form.area,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.msg)
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    // 群信息修改
    qqConfirm() {
      qq_modify({
        id: this.qqForm.id,
        areaPath: this.qqForm.areaPath,
        category: this.qqForm.category,
      }).then((res) => {
        this.visible = !this.visible
        if (res.code === 1) {
          this.checkStatusG = undefined
          this.checkGroup()

          this.$message.success(res.msg)
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    // 群信息修改取消
    qqCancel() {
      this.visible = !this.visible
      // 数据清除
      this.qqForm.id = this.qqForm.area = this.qqForm.category = undefined
      this.qqForm.areaPath = []
    },
  },
  computed: {
    formCode() {
      return this.form.code
    },
    formGroup() {
      return this.form.group
    },
  },
  watch: {
    formCode() {
      this.checkStatus = undefined
    },
    formGroup() {
      this.checkStatusG = undefined
    },
  },
}
</script>

<style scoped>
.check-icon {
  cursor: pointer;
  margin-left: 10px;
  font-size: 16px;
}
</style>
